import React, { useState, useEffect } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Badge, OverlayTrigger, Popover } from 'react-bootstrap';
import { isObject } from 'lodash';
import { useProductListingState } from '../RangePlanProductListingProvider';
import noImage from '../../../../assets/images/no-image.png';
import CommonImageComponent from '../../../../Components/Utility/CommonImage';
import Loader from '../../../../Components/Utility/Loader/Loader';

export default function ProductSpecification(props) {
  const { handlePageNextInScroll, loadNextData, handleSelection, selectedIds, isSelectAll } = props;
  const { t } = useTranslation('common');

  const {
    rangePlanProvider: { productsNumber, productsList },
  } = useProductListingState();

  const [expandedRowIndex, setExpandedRowIndex] = useState([]);
  const [isExpandAll, setIsExpandAll] = useState(false);

  useEffect(() => {
    if (isExpandAll && productsList?.length > 0) {
      setExpandedRowIndex(productsList.map((_, index) => index));
    }
  }, [productsList?.length]);

  const getValue = (value) => {
    if (isObject(value)) {
      return value?.name || '';
    }
    return value || '--';
  };

  const expandMoreData = (index) => {
    if (expandedRowIndex.includes(index)) {
      setIsExpandAll(false);
      setExpandedRowIndex(expandedRowIndex.filter((item) => item !== index));
    } else {
      setExpandedRowIndex([...expandedRowIndex, index]);
    }
  };

  const expandAllProdIdentifier = () => {
    if (isExpandAll) {
      setIsExpandAll(false);
      setExpandedRowIndex([]);
    } else {
      setIsExpandAll(true);
      setExpandedRowIndex(productsList?.map((_, index) => index) || []);
    }
  };
  return (
    <div id="ProductIdentifierRPTableContainer" className="rp-scroll-container">
      <InfiniteScroll
        dataLength={productsList?.length}
        hasMore={productsList?.length < productsNumber}
        next={handlePageNextInScroll}
        loader={loadNextData && <Loader />}
        className="fixed-col-container rp-table-container"
        scrollableTarget="ProductIdentifierRPTableContainer"
      >
        <table id="RPProductSpecTable" className="table common-custom-table fixed-header mb-0">
          <thead>
            <tr>
              <th className="w-50px">
                <div className="common-checkbox margin-auto">
                  <input
                    type="checkbox"
                    onChange={(e) => handleSelection(e.target.checked)}
                    name="check_all_product_spec"
                    id="check_all_product_spec"
                    checked={isSelectAll}
                    disabled={!productsList?.length}
                  />
                  <label htmlFor="check_all_product_spec" className="chklabel" />
                </div>
              </th>
              <th className="w-50px">
                <button type="button" className="btn-up-down" aria-label={t('COMMON_LABEL.COLLAPSE')} onClick={() => expandAllProdIdentifier()}>
                  {isExpandAll ? <span className="icon-new-down-arrow-icon icon-inverse" /> : <span className="icon-new-down-arrow-icon " />}
                </button>
              </th>
              <th className="w-80px">{t('RANGE_PLANS.PRODUCT_LIST.IMAGE')}</th>
              <th className="w-220px first-fix-col">{t('RANGE_PLANS.PRODUCT_LIST.PRODUCT_NUMBER')}</th>
              <th className="w-220px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_MEASUREMENT.GRADING_GROUP')}</th>
              <th className="w-200px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_MEASUREMENT.SIZE')}</th>
              <th className="w-200px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_MEASUREMENT.SPEC_DOCS')}</th>
              <th className="w-200px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_MEASUREMENT.POM')}</th>
              <th className="w-140px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_MEASUREMENT.MEASUREMENT_UNIT')}</th>
              <th className="w-200px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_MEASUREMENT.WEIGHT')}</th>
              <th className="w-200px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_MEASUREMENT.VOLUME')}</th>
            </tr>
          </thead>

          {productsList?.length > 0 ? (
            productsList?.map((ele, productIndex) => {
              const initialData = ele?.initialData;

              const productImage = ele?.image || noImage;
              return (
                <tbody key={ele?._id}>
                  <tr>
                    <td>
                      <div className="common-checkbox margin-auto">
                        <input
                          onChange={() => {
                            handleSelection(ele?._id);
                          }}
                          name={`checks_${productIndex}`}
                          id={`checks_${productIndex}`}
                          type="checkbox"
                          checked={selectedIds?.filter((val) => val === ele?._id)?.length > 0}
                        />
                        <label htmlFor={`checks_${productIndex}`} className="chklabel" />
                      </div>
                    </td>
                    <td>
                      {ele?.expandData?.length > 0 && (
                        <button type="button" className="btn-up-down" aria-label={t('COMMON_LABEL.COLLAPSE')} onClick={() => expandMoreData(productIndex)}>
                          {expandedRowIndex.includes(productIndex) ? (
                            <span className="icon-new-down-arrow-icon icon-inverse" />
                          ) : (
                            <span className="icon-new-down-arrow-icon" />
                          )}
                        </button>
                      )}
                    </td>
                    <td>
                      <CommonImageComponent productImage={productImage} />
                    </td>
                    <td className="first-fix-col">
                      <div className="d-flex align-items-center">
                        {ele?.number}
                        <button type="button" className="btn ml-auto" aria-label="info">
                          <OverlayTrigger
                            placement={t('TAKING_DATES.BUTTON')}
                            trigger="hover"
                            rootClose
                            overlay={
                              <Popover className="custom-popover">
                                <Popover.Content>
                                  <p className="mb-8">
                                    <b className="text-bold">Product Type: </b>
                                    {getValue(ele?.supplierType)}
                                  </p>
                                  <p className="mb-8">
                                    <b className="text-bold">Description: </b>
                                    {getValue(ele?.description)}
                                  </p>
                                  <p className="mb-8">
                                    <b className="text-bold">Brand: </b>
                                    {getValue(ele?.brandId)}
                                  </p>
                                  <p className="mb-8">
                                    <b className="text-bold">Season: </b>
                                    {getValue(ele?.seasonId)}
                                  </p>
                                  <p className="mb-8">
                                    <b className="text-bold">Month: </b>
                                    {getValue(ele?.month)}
                                  </p>
                                  <p className="mb-8">
                                    <b className="text-bold">Year: </b>
                                    {getValue(ele?.year)}
                                  </p>
                                  <p className="mb-8">
                                    <b className="text-bold">Colourway(s): </b>

                                    {ele?.colourLibraries?.map((gradEle) => gradEle?.name)?.join(', ') || '--'}
                                  </p>
                                  <p className="mb-8">
                                    <b className="text-bold">Size: </b>
                                    {ele?.sizeRanges?.join(', ') || '--'}
                                  </p>
                                </Popover.Content>
                              </Popover>
                            }
                          >
                            <span className="icon icon-Information f-20" />
                          </OverlayTrigger>
                        </button>
                      </div>
                    </td>
                    <td>
                      <div className="d-flex align-items-center">
                        {initialData?.gradingGroupName || '--'}
                        {ele?.expandData?.length > 0 && (
                          <Link target="_blank" to={`/development-order/${ele?._id}/measurement`} className="px-3 ml-auto text-decoration-none">
                            <span className="icon-redirect f-20" />
                          </Link>
                        )}
                        <div style={{ width: 20 }}>
                          {ele?.expandData?.length > 0 && <Badge className="range-badge badge badge-rp-counter">{(ele?.expandData?.length || 0) + 1}</Badge>}
                        </div>
                      </div>
                    </td>
                    <td>
                      {initialData?.sizeRanges
                        ?.map((eleSize) => {
                          return eleSize;
                        })
                        ?.join(', ') || '--'}
                    </td>
                    <td>{initialData?.supportingDocuments || 0}</td>
                    <td>{initialData?.POM || '--'}</td>
                    <td className="text-uppercase">{initialData?.measurementUnit || '--'}</td>
                    <td>
                      {initialData?.weightVolData?.length > 0
                        ? initialData?.weightVolData?.map(
                            (item, index) =>
                              `${item?.weight || '-'} ${item?.weightUnit?.label || '-'}${index !== initialData?.weightVolData?.length - 1 ? ', ' : ''}`,
                          )
                        : '0'}
                    </td>
                    <td>
                      {initialData?.weightVolData?.length > 0
                        ? initialData?.weightVolData?.map(
                            (item, index) =>
                              `${item?.volume || '-'} ${item?.volumeUnit?.label || '-'}${index !== initialData?.weightVolData?.length - 1 ? ', ' : ''}`,
                          )
                        : '0'}
                    </td>
                  </tr>
                  {expandedRowIndex.includes(productIndex) &&
                    ele?.expandData?.map((expData) => {
                      return (
                        <tr className="expand-row" key={expData?._id}>
                          <td />
                          <td />
                          <td />
                          <td className="first-fix-col">{expData?.referenceCode}</td>
                          <td>{expData?.gradingGroupName}</td>
                          <td>
                            {expData?.sizeRanges
                              ?.map((eleSize) => {
                                return eleSize;
                              })
                              ?.join(', ')}
                          </td>
                          <td>{expData?.supportingDocuments}</td>
                          <td>{expData?.POM}</td>
                          <td className="text-uppercase">{expData?.measurementUnit}</td>
                          <td>
                            {expData?.weightVolData?.length > 0
                              ? expData?.weightVolData?.map(
                                  (item, index) =>
                                    `${item?.weight || '-'} ${item?.weightUnit?.label || '-'}${index !== expData?.weightVolData?.length - 1 ? ', ' : ''}`,
                                )
                              : '0'}
                          </td>
                          <td>
                            {expData?.weightVolData?.length > 0
                              ? expData?.weightVolData?.map(
                                  (item, index) =>
                                    `${item?.volume || '-'} ${item?.volumeUnit?.label || '-'}${index !== expData?.weightVolData?.length - 1 ? ', ' : ''}`,
                                )
                              : '0'}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              );
            })
          ) : (
            <tr>
              <td colSpan={11} className="text-center">
                {t('RANGE_PLANS.PRODUCT_LIST.NO_RECORDS_FOUND')}
              </td>
            </tr>
          )}
        </table>
      </InfiniteScroll>
    </div>
  );
}
